<app-expandable-table [info]=info></app-expandable-table>